var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
const html_404 = html `
<div class="card">
    <div class="card-content">
        <div class="columns is-flex is-centered">
            <figure class="image is-inline-block">
                <img src="/assets/images/404.jpg" alt="404 page not found" />
            </figure>
        </div>
    </div>
</div>`;
export { html_404 };
let AppNotFound = class AppNotFound extends LitElement {
    constructor() {
        super();
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html_404;
    }
};
AppNotFound = __decorate([
    customElement('app-notfound')
], AppNotFound);
export { AppNotFound };
//# sourceMappingURL=anon_notfound.js.map